module.exports = __webpack_public_path__ + "static/assets/9c77b5cc0548467351fa9275f670e374.png";